import React from 'react';

import './index.scss';

export const DualBoxLeft = (props) => {

  return (
    <div className={`dualbox__box dualbox__box--left ${props.className}`}>
      {props.noContent ? (
        props.children
      ) : (
        <div className="dualbox__content">
          {props.children}
        </div>
      )}

    </div>
  );
};

export const DualBoxRight = (props) => {

  return (
    <div className={`dualbox__box dualbox__box--right ${props.className}`}>
      <div className="dualbox__content">
        {props.children}
      </div>
    </div>
  );
};

export const DualBox = (props) => {

  return (
    <div className={`dualbox ${props.className}`}>
      {props.children}
    </div>
  );
};

export default { DualBox, DualBoxLeft, DualBoxRight };
